import { useNavigate } from "react-router-dom";
import EntryForm from "./EntryForm";
import { useTranslation } from "react-i18next";
import CommonUtilities from "../Utils/CommonUtilities";
import { RootState } from "../../../store/store";
import { useSelector } from "react-redux";
import * as constants from "../../../constants";


const ManualEntries = () => {
  const { t } = useTranslation();
  const translate = t as (key: string) => string;
  const transactionTypes = CommonUtilities.manualTransactionTypes;
  const AdminProfile = useSelector((state: RootState) => state.participantAdminProfile);
  return (
    <EntryForm
      accountType={true}
      methodOfPayment={true}
      participantField={true}
      commentsField={true}
      typeOfTransactions={true}
      dateOfTransactions={true}
      checkReferenceField={true}
      creditLineClose={false}
      amountField={true}
      transactionTypes={transactionTypes}
      pageType="checkingAndSavings"
      headingMessage={translate('manualTransactionEntries')}
      navigationPath={AdminProfile.participantAdminProfile === constants.ADMIN_VIEW ? "/rcboSummary" : "/summary"}
    />
  );
};

export default ManualEntries;
